// extracted by mini-css-extract-plugin
export default {"root":"TranscriptOnlyFootnote-module__root_ODYVR","icon":"TranscriptOnlyFootnote-module__icon_diNcR","text":"TranscriptOnlyFootnote-module__text_MbFzG"};